module.exports = __webpack_public_path__ + "img/account-2.03068fd6.png";